import Grid from "@mui/material/Grid";
import React from "react";
import ServiceSearch from "../UI/SearchComponent";
import Button from "components/UI/Button";
import { Main } from "styles/themeColors";
import Vendor from "data/Vendor";
import styled from "styled-components";
import { styled as muiStyled } from '@mui/material/styles';
import ServiceLocalization from "./ServiceLocalization";
import { FontWeight } from "lib/styles";
import { PermissionCode } from "data/UserPermissions";

const Heading = styled.span`
  font-weight: ${FontWeight.bold};
  font-size: 24px;
`;

const GridPadding = muiStyled(Grid)({
    padding: '0 20px',
});

interface Props {
    searchTerm: string;
    setSearchTerm: (value: string) => void;
    onClickNewService: () => void;
    selectedVendor: Vendor;
}

const ServiceListHeader = ({ searchTerm, setSearchTerm, onClickNewService, selectedVendor }: Props) => {

    return (
        <GridPadding container flexDirection={'row'} alignItems="center" justifyContent='space-between' sx={{ width: '100%' }}>
            <Heading className="heading">{ServiceLocalization.addons}</Heading>
            {
                selectedVendor &&
                <>
                    <ServiceSearch searchTerm={searchTerm} setSearchTerm={setSearchTerm} placeHolder={ServiceLocalization.searchPlaceholder} />
                    <Grid
                        size={{ xs: 12, sm: 6, md: 6 }}
                        container
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        <Button
                            onClick={onClickNewService}
                            bgColor={Main.brandDark}
                            borderColor={Main.brandDark}
                            permissionCode={PermissionCode.ADDONS_CREATE}
                        >
                            {ServiceLocalization.newAddon}
                        </Button>
                    </Grid>
                </>
            }
        </GridPadding>
    );
}

export default React.memo(ServiceListHeader);